import { Component, Inject } from '@angular/core';
import {
    FormControl,
    FormsModule,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateService } from '@ngx-translate/core';
import {
    AddCommentDialogModel,
    AddCommentDialogReceiveModel,
} from '../../models/add-comment-dialog-model';
import { SharedDialogShellConfig } from '../../models/shared-dialog-shell-config';
import { SharedDialogShellComponent } from '../shared-dialog-shell/shared-dialog-shell.component';

@Component({
    selector: 'apcam-add-comment-confirmation',
    templateUrl: './add-comment-dialog.component.html',
    styleUrls: ['./add-comment-dialog.component.scss'],
    imports: [
        FormsModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        SharedDialogShellComponent,
    ],
})
export class AddCommentDialogComponent {
    protected get dialogShellConfig(): SharedDialogShellConfig<AddCommentDialogReceiveModel> {
        return {
            title: this.data.summary,
            cancelLabel: this.translateService.instant('shared.buttons.cancel'),
            confirmLabel: this.data.submitBtnText,
            confirmDisabled: this.comment.invalid,
            onConfirm: () => ({ commentText: this.comment.value }),
        };
    }

    comment: FormControl = new FormControl('', Validators.required);

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: AddCommentDialogModel,
        private readonly translateService: TranslateService
    ) {}
}
